if ($('.videoFrame').length > 0) {
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  var player;
  
  function onYouTubeIframeAPIReady() {
    $('.videoFrame').each(function(i,v){
      var video_id = $(this).attr('data-videopp-id');
      var sec_id = $(this).attr('id');
      var autoplay = 1;
      var loop = 1;
      autoplay = parseInt(autoplay);
      var parent_id = $(this).attr('data-parent');
      var player;
      player = new YT.Player(sec_id, {
        height: '680',
        width: '1920',
        videoId: video_id,
        playerVars: {
          autohide: 0,
          branding: 0,
          cc_load_policy: 0,
          controls: 0,
          fs: 1,
          loop: 1,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          quality: 'hd720',
          rel: 1,
          showinfo: 1,
          wmode: 'opaque'
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      function onPlayerReady(event) {
        event.target.mute();
        event.target.playVideo();
      }
      function onPlayerStateChange(event) {
        setInterval(function() {
          if(player.getCurrentTime() > 0){
            // console.log(player.getCurrentTime());
            var element = document.getElementById(parent_id);
            element.classList.remove("poster_get");
          }
        }, 1000);
        if (event.data == YT.PlayerState.ENDED) {  
          player.seekTo(0);
          player.playVideo();
        }
      }
    });
  }
}

  
  function setCookie(cname,cvalue,exdays) {
   const d = new Date();
   d.setTime(d.getTime() + (exdays*24*60*60*1000));
   let expires = "expires=" + d.toUTCString();
   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
  }


 $(window).on('load',function(){   

   
  function closePopup() {
    $('.popupBox').removeClass('fadeInUp');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('body').removeClass('popupOpned');
    
    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupBox').addClass('fadeInUp');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

//   $('.topbar a').on('click', function(e){
//     e.preventDefault();
//     openPopup('topbarShipping');
//   });


  $('.pdpShippingMsg a').on('click', function(e){
    e.preventDefault();
    openPopup('addnlContent');
  });

  function refreshHeigh() {
    var bh = $('.cartButtonOuter').height()+70;
    var vh = window.innerHeight;
    var newh = vh-bh;
    var qih = $('.quick-items').height();
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 115) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  // refreshHeigh();

  // $(window).resize(function(){
  //   setTimeout(function() {
  //     refreshHeigh();
  //     $('.cartDrawer').css("height", window.innerHeight+'px');
  //   }, 50);
   
  // });
   
  if ($(window).width() > 991) {
      $(document).on({
        mouseenter: function() {
          $(".mainSections").addClass('menuHover');
          $('.site-nav').addClass('menuBg');
        },
        mouseleave: function() {
          $(".mainSections").removeClass('menuHover');
          $('.site-nav').removeClass('menuBg');
        }
      }, ".hasDropDown");
   }

  /* Site update+FVnext  */
  function scroll_stick_add_to_cart(){
    if($('.cutsom_button').length > 0 && (window.location.href.indexOf('is_sticky_atc=true') > -1 || window.sticky_add_to_cart == true)){
      $(".cutsom_button").removeClass("is-visible").removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();

      var elemTop = $('.cutsom_button').offset().top;
      var elemBottom = elemTop + $('.cutsom_button').height();

      if (scroll >= elemBottom) {
        $(".cutsom_button").addClass("is-visible").addClass("ProductStickyAddToCart");
        if($(window).width() < 769){
          $('body').css("padding-bottom",$('.cutsom_button').outerHeight()+"px");
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function() {    
    scroll_stick_add_to_cart();
  });

  $window = $(window);
  $slick_slider = $('.proImgClrGroup');
  settings = {
    centerMode: false,
    arrows: false,
    dots: true, 
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  if ($window.width() <= 991) {
    $slick_slider.slick(settings);
  }
   
  $window.on('resize load', function () {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick');
      }
    } else if (!$slick_slider.hasClass('slick-initialized')) {
      return $slick_slider.slick(settings);
    }
  });

  if (new URLSearchParams(window.location.search).get('app') === 'kinn') {
    $("div.topbar-rolling-text:has(p.hide-in-app) > p.hide-in-app").remove();
    $("div.hide_on_app").remove();
    $(".app_hide").remove();
    $(".app_only").parent().show();
  } else {
    $(".app_only").parent().remove();
  }

  
  $('body').on("click",'.closeZoom', function(){
    closeZoom();
  });

  $('body').on("click", function(e) {
    if ($(e.target)[0] != $('.zoomImgsCont')[0] || $(e.target)[0] != $('.zoom_element')[0]) {
      if ($(e.target)[0] == $('.zoomImgsWrap')[0]) {
        closeZoom();
      }
    }
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });
  
  var closeZoom = function () {
    $('.zoomImgsWrap').remove();
    $('body').removeClass('ovfHidden');
    $('.mainImg').removeClass('current');
  }

  var pt = window.sm_theme.variable.product_title;
  $('.proImgClrGroup .featuredSlide .zoom_object').on("click",function(){
    $('.proImgClrGroup .featuredSlide .zoom_object').removeClass('current');
    $(this).addClass('current');
    $('body').addClass('ovfHidden');
    $('body').append('<div class="zoomImgsWrap"><div class="zoomimage_wrapper"><div class="zoomImgsCont"></div> <button class="closeZoom">X</button></div></div>');
    $(this).closest('.proImgClrGroup').find('.product-image:not(.slick-cloned) .zoom_object').each(function() {
      if ($(this).hasClass('type_image')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<img class="zoomTo zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
        else
          $('.zoomImgsCont').append('<img class="zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
      } else if ($(this).hasClass('type_video')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<video class="zoomTo zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
        else
          $('.zoomImgsCont').append('<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
      }
    });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs.load(function() {
      count--;
      if (!count) {
        //setTimeout(function(){
        var s = $(".zoomImgsCont .zoom_element.zoomTo").position().top;
        $('.zoomImgsCont').animate({ scrollTop: s }, 1000);
        //},500);
      }
    }).filter(function() { return this.complete; }).load();

  });
  
  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
    }
  });

  $('.mobileNav').on('click',function(e){
    e.preventDefault();
    const $header = $('#shopify-section-header');
    jQuery('.mobileMenu').css('top',$header.offset().top + $header.height() + 'px');
    jQuery('.mobileMenu').css('height','calc(100% - '+(jQuery('#shopify-section-header').outerHeight()+ jQuery('#shopify-section-announcement-banner').outerHeight())+'px)');
    if($(this).parents('.fullPage').hasClass('witmenu')){
      setTimeout(function(){
        $('body').removeClass('menuOpen');
        $('.fullPage').removeClass('witmenu');
      }, 100);
    } else {
      setTimeout(function(){
        $('body').addClass('menuOpen');
        $('.fullPage').addClass('witmenu');
      }, 100);
    }
  });
   
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
   
  $('.closeFilter').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').removeClass('filterOpen');
      $('.fullPage').removeClass('witmenu');
    }, 50);
  });
  
  $('#mainNavMob').on('click','.toggleItem.level2',function(e){
 //   $('.mobileMenu').addClass('mobfoxheight');
 //   $('.mobileMenu')[0].scrollTop = 0;
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }

  });
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    $('.mobileMenu').removeClass('mobfoxheight');
  });
   
  // $('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
  //   var h = $(this).closest('ul')[0].scrollHeight;
  //   $(this).closest('ul')[0].scrollTop = 0;
  //   $(this).closest('ul').css('overflow','hidden');
  //   $(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');

  // });

  jQuery('#mainNavMob').on('click','.toggleItem.level3',function(e){
    jQuery(this).closest('li.col_menu_only').addClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').addClass('open_childofchild');
    localStorage.setItem("secondScroll", jQuery('.toggleSubMenu').scrollTop());
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = 0;
  });
  jQuery('#mainNavMob').on('click','.backTitle3',function(e){
    jQuery(this).closest('li.col_menu_only').removeClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').removeClass('open_childofchild');
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = localStorage.getItem("secondScroll");
  });

  // $('#mainNavMob').on('click','.backTitle3',function(e){
  //   var btn = $(this);
  //   btn.closest('.toggleSubMenu').removeAttr('style');
  //   btn.closest('ul').addClass('hidemenu_step3');
  //   setTimeout(function(){
  //     btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
  //   },500);
  // });

  if (jQuery(window).width() <= 991) {
    jQuery('body').on('click','.site-nav>li>span>.toggleItem', function(e){
      e.preventDefault();
      $('.navbar')[0].scrollTop = 0;
      $(this).parents(".hasDropDown").find(".dropdownmenu").addClass("toggleSubMenu").css({'transform':'translate(0)','-webkit-transform':'translateX(0)'});
    });
    
    jQuery('body').on('click','.backTitle', function(e){
      e.preventDefault();
      $(this).parents(".hasDropDown").find(".dropdownmenu").removeClass("toggleSubMenu").css({'transform':'unset','-webkit-transform':'unset'});
    });
  }
   
  $('body').on('click','.openThird',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeAttr('style');
    btn.closest('.hasThird').addClass('thirdNavOpen');
  });
  
  $('body').on('click','.hasThird h4',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeClass('thirdNavOpen');
  });
  
  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    if($(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });
  
  
  
  $('.mobToggler').on('click',function(e){
    $(this).next('div').slideToggle();
    $(this).toggleClass('opned');
  });
  window.onload = function() {
    $('.full_banner').each(function(){
      var img = $(this).attr('data-banner');
      $(this).css('background-image','url('+img+')');
      $(this).find('img').attr('src',img);
    });
    if($(window).width() <= 991) {
      $('.afterLoad').each(function(){
        var img = $(this).attr('data-src');
        $(this).attr('src', img);
      });
    }
  };

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      var new_data = data.split('[cartsplit]'), cart_count = 0;
      $('body #main-cart-wrapper #cart-item-form [data-cart-items]').html(new_data[0]);
      $('body #main-cart-wrapper .cartTotal[data-cart-subtotal]').html(new_data[1]);

      $('#crt').removeClass('loading');
      
      // setTimeout(function() {
      //   refreshHeigh();
      //   $('.cartDrawer').css("height", window.innerHeight+'px');
      // }, 100); 
      //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
      //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 

        $.getJSON('/cart.js', function(c){
          if (c.item_count == 0){
            $('.cartButtonOuter').hide().parents('#crt').removeClass('has-item');
          } else {
            $('.cartButtonOuter').show().parents('#crt').addClass('has-item');
          }
        });
      
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
    });
  }

  $('.cartOuter').on('mouseenter, click',function(e){
    if($(this).find('.cartCount').text()!="0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });
   
  // $('.cartCount').on("DOMSubtreeModified",function(){
  //   addToCartSuccess();
  // });

 var atcText = '', addedToCart = '';
 if (window.shop_locale == 'nl') (atcText = 'Toevoegen...', addedToCart = 'Voeg toe aan winkelmand');
 else if (window.shop_locale == 'fr') (atcText = 'Ajouter...', addedToCart = 'Ajouter au panier');
 else if (window.shop_locale == 'de') (atcText = 'Hinzufügen...', addedToCart = 'In den Warenkorb');
 else (atcText = 'Adding...', addedToCart = 'Add to my basket');
   
 $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.val(atcText);
    form.find('.error').remove();
 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val(addedToCart);
        btn.removeAttr('disabled');
      },
      success: function(product) {
        var _learnq = _learnq || [];
        var item = {
          Name: product.product_title,
          ProductID: product.product_id,
          ImageURL: product.image,
          URL: window.location.href,
          Brand: product.vendor,
          Price: product.price/100
        };
        _learnq.push(['track', 'Added to Cart', item]);
      }
    }).done(function( data ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "ga4addToCart",
        addToCart: {products: data},
      });
      addToCartSuccess();
      btn.val(addedToCart);
      btn.removeAttr('disabled');
      // QUICK SHOP
      if (btn.hasClass('quickAdd')) {
        $('.product_quickview, .overlay').removeClass('active');
        $('body').removeClass('Fixed');
      }
      // QUICK SHOP
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      // if(!c.item_count) {
      //   $('.itemCount').text('0');
      //   $('#crt').empty();
      //   $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
      //   $('#crt').removeClass('has-item');
      //   $('#crt').removeClass('loading');
      // }/* else {
      //   addToCartSuccess();
      // }*/
      addToCartSuccess();
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    if (!$(this).hasClass('upsell_qty')) {
      $('#crt').addClass('loading');
      var id = parseInt(input.attr('data-id'));
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'updates['+id+']='+ip,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
          $('#crt').removeClass('loading');
        },
        success: function(){
          addToCartSuccess();
          $.getJSON('/cart.js', function(c){
            $('.itemCount, .cartCount').text(c.item_count);
          });
          $('#crt').removeClass('loading');
        }
      });
    }

  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

   $('.tablist ul li').click(function(e){
     if(!$(this).parents('.tablist').hasClass('tablist_404')){
       e.preventDefault();
       $('.tablist ul li').removeClass('activetab');
       $('.relatedProductC').hide();
       var currenTab = $(this).data('id');
       $(this).addClass('activetab');
       $('#'+currenTab).show();
       //var x = $(this).attr('data-slick');
       if($('.responsive').hasClass('slick-initialized')) {
         $('.responsive').slick('refresh');
       }
     }
   });


    $('.responsive').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  
  
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });
   
  var baseURL = "https://services.superga-usa.com/";
  /*$('.mainNewsletter').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }

    if(x){
      $.ajax({
        type: "POST",
        url: baseURL + 'Responsys/AddNewsLetter',
        data: "email="+email+"&page=PopUp",
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          $('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });*/
  

  jQuery('#footerNewsletter').submit(function(event) {

    //this will prevent the default submit
    event.preventDefault(); 
    jQuery('.error').remove();
    var form = jQuery(this);
    var email = form.find("#footeremail").val();
    var source = 'Site Signups (Footer)';    
    var x = true;
    var flag = 1;
    jQuery('.err-msg').remove();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail...</p>');
      x = false;
      return false;
    } else {
      em.parent().find('.err-msg').remove();

      var source = 'Sign Up footer';
      var language = form.find('.language').val();
      var list_id = form.find('.listID').val();

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": list_id,
          "email": email,
          "$source": source,
          "$language": language,
          "Accepts Marketing": false,
          "$fields": "$source, $language, Accepts Marketing"
        },
        success: function(){
          form.hide();
          form.parent().append('<p style="text-align:center;">Thanks for joining.</p>'); 
        },
        error: function(data, errorThrown) {
          jQuery('.error').remove();
          if(data.statusText == "BAD REQUEST") {
            form.parent().append('<p class="error">The email already subsribed!</p>');
          }

        }
      };
 
      jQuery.ajax(settings).done(function (response) {
        
      });

    }

  });
  
  
  $('#moreAboutYou').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }
    
    if($('#agreementSMPass:checked').length) {
      var pc = form.find("input[name='pcode']");
      if(pc.val().trim() == '') {
        pc.parent().append('<p class="err-msg">Please enter Postal code.</p>');
        x = false;
      } else {
        pc.parent().find('.err-msg').remove();
      }
      
      var tp = form.find("input[name='telephone']");
      if(tp.val().trim() == '') {
        tp.parent().append('<p class="err-msg">Please enter Telephone.</p>');
        x = false;
      } else {
        tp.parent().find('.err-msg').remove();
      }
    }

    if(x){
      var mydata={
        email: email,
        page:"Footer"
      };
      $.ajax({
        type: "POST",
        url: baseURL + '*********',
        data: mydata,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
           
        },
        error: function (e) {
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });

             /* maddenqood page*/
   $(window).scroll(function () { 
     if($('.maddenwood_header_section').length > 0){
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
          $(".maddenwood_header_right").addClass("maddenwood_header-sticky");
      } else {
          $(".maddenwood_header_right").removeClass("maddenwood_header-sticky");
      }
     }
 });    

    $('.paloma-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        adaptiveHeight: true
    });


  if($(window).width() <= 991){
    var video_class = 'video.mobile_imgonly';
  } else{
    var video_class = 'video.desktop_imgonly';
  }
    //play button
    $("body").on('click','.main-btn.maddenwood_play_btn',function (e) {
      e.preventDefault();
        $(this).closest('.maddenwood_hero_section').find(".main-popup").toggleClass("active");
        $('body,html').toggleClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];
        if (get_video.paused){
          get_video.muted = false;
          get_video.play();
        }              
    });
    $("body").on("click",'.maddednwooed_popup .close-menu',function (e) {
      e.preventDefault();
        $(".main-popup").removeClass("active");
        $('body,html').removeClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];            
        get_video.muted = true;
        get_video.pause();                
    });
  /*maddenwood end */
  
});

$(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
  
  $('body').on('click','.single-qty .qty-btn', function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    console.log(ip, 'before');
    if($(this).hasClass('plus-symbol')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    console.log(ip, 'after');
    input.val(ip);
  }); 
  
  function addtocart(){
    $.get('/cart',function(data){
      var html = $(data).find('.cart-details').html();
      $('.cart-details').html(html);
    });
  }
  $('body').on('click','.btnadd',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.val(atcText);
    $.ajax({
      type : 'POST',
      url : '/cart/add.js',
      data :form.serialize(),   
      dataType: 'json',
      error : function(jqXHR, textStatus, errorThrown){        
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut(); 
        $('#load-spinner').removeClass('loader');
      },
      success : function(){
        addtocart();
        $.getJSON('/cart.js', function(c){
          $('.cartCount').text(c.item_count);
        });
      }
    });
  });

  
 
});



$(document).ready(function(){
  function review_scroll(){
    if($('#reviews').outerHeight() > 0){
      $('html,body').animate({
        scrollTop: $('#reviews').offset().top
      }, 2000);
      return;
    }else{
      setTimeout(function(){
        review_scroll();
      },1000);
    }
  }
  var url = window.location.hash;
  if (url == '#reviews'){
    review_scroll();
  }
  
  
   $('body').on('click',".review_a .text-m",function(e){
    e.preventDefault();
    window.location = $(this).closest('.review_a').attr('href');
  });
  

   var c = 0; 
  function find_teaser(){
    if($('.kl-teaser-UD6ayU').length > 0 || $('.kl-teaser-XXfacM').length > 0 || $('.kl-teaser-WRwPw2').length > 0 || $('.kl-teaser-RHiFUr').length > 0 || $('.kl-teaser-SYxkxZ').length > 0 || $('.kl-teaser-WbF49N').length > 0 || $('.kl-teaser-TrbrGz').length > 0){
      if(getCookie("teaser_closed") != 'yes'){
        if($('.kl-teaser-UD6ayU').length > 0){
          $('.kl-teaser-UD6ayU').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if($('.kl-teaser-RHiFUr').length > 0){
          $('.kl-teaser-RHiFUr').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if($('.kl-teaser-XXfacM').length > 0) {
          $('.kl-teaser-XXfacM').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if ($('.kl-teaser-WRwPw2').length > 0){
          $('.kl-teaser-WRwPw2').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if ($('.kl-teaser-SYxkxZ').length > 0){
          $('.kl-teaser-SYxkxZ').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if ($('.kl-teaser-WbF49N').length > 0){
          $('.kl-teaser-WbF49N').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
        if ($('.kl-teaser-TrbrGz').length > 0){
          $('.kl-teaser-TrbrGz').parent().append('<div class="close klaviyo_teaser_close">x</div>');
        }
      } else{
        if($('.kl-teaser-UD6ayU').length > 0){
          $('.kl-teaser-UD6ayU').css("top","unset");
        }
        if($('.kl-teaser-RHiFUr').length > 0){
          $('.kl-teaser-RHiFUr').css("top","unset");
        }
        if($('.kl-teaser-XXfacM').length > 0) {
          $('.kl-teaser-XXfacM').css("top","unset");
        }
        if ($('.kl-teaser-WRwPw2').length > 0){
          $('.kl-teaser-WRwPw2').css("top","unset");
        }
        if ($('.kl-teaser-SYxkxZ').length > 0){
          $('.kl-teaser-SYxkxZ').css("top","unset");
        }
        if ($('.kl-teaser-WbF49N').length > 0){
          $('.kl-teaser-WbF49N').css("top","unset");
        }
        if ($('.kl-teaser-TrbrGz').length > 0){
          $('.kl-teaser-TrbrGz').css("top","unset");
        }
      }
      return;
    } else{
      if (c < 20){
        setTimeout(function(){
          find_teaser();
        },1000);
        c++;
      }else{
        return;
      }
    }
  }
  
  find_teaser();

  $('body').on("click",".close.klaviyo_teaser_close",function(e){
    if($('.kl-teaser-UD6ayU').length > 0){
      $(this).hide().parent().find('.kl-teaser-UD6ayU').css("top","unset");
    }
    if($('.kl-teaser-RHiFUr').length > 0){
      $(this).hide().parent().find('.kl-teaser-RHiFUr').css("top","unset");
    }
    if($('.kl-teaser-XXfacM').length > 0) {
      $(this).hide().parent().find('.kl-teaser-XXfacM').css("top","unset");
    }
    if ($('.kl-teaser-WRwPw2').length > 0){
      $(this).hide().parent().find('.kl-teaser-WRwPw2').css("top","unset");
    }
    if ($('.kl-teaser-SYxkxZ').length > 0){
      $(this).hide().parent().find('.kl-teaser-SYxkxZ').css("top","unset");
    }
    if ($('.kl-teaser-WbF49N').length > 0){
      $(this).hide().parent().find('.kl-teaser-WbF49N').css("top","unset");
    }
    if ($('.kl-teaser-TrbrGz').length > 0){
      $(this).hide().parent().find('.kl-teaser-TrbrGz').css("top","unset");
    }
    setCookie("teaser_closed","yes");
    $('.klaviyo_teaser_close').remove();
  });
  
  $('body').on("click",".klaviyo-close-form",function(){
    find_teaser();
  });
  
  $('body').on("click","button.kl-teaser-UD6ayU.needsclick,button.kl-teaser-WRwPw2.needsclick,button.kl-teaser-XXfacM.needsclick,button.kl-teaser-RHiFUr.needsclick,button.kl-teaser-SYxkxZ.needsclick,button.kl-teaser-WbF49N.needsclick,button.kl-teaser-TrbrGz.needsclick",function(){
    $('.klaviyo_teaser_close').remove();
  });

    $(".shoeGlossary .head-links a").click(function(){
      if(!$(this).hasClass('inactive-link')&&!$(this).hasClass('selected'))
      {
        $(".head-links a").each(function(){
          $(this).removeClass('selected');
        })
  
        $(this).addClass('selected');
  
        var y = $(this).attr("id");
  
        if($(this).hasClass('all')){
          $('.toggle-item').each(function(){
            if(!$(this).hasClass('inactive')){
              $(this).css('display','block');
            }
          })
          $('.back-to-top').css('display','inline');
        }else{
          $('.back-to-top').css('display','none');
          $('.toggle-item').each(function(){
            if($(this).hasClass('toggle-item-'+y)){
              $(this).css('display','block');
            }else{
              $(this).css('display','none')
            }
          })
        } 
  
      } 
      return false;
    });

    $('.shoeGlossary .back-to-top a').click(function(){
      $('html, body').animate({
        scrollTop: $("#cachedTC_TCArea_1").offset().top
      }, 500);
    });

    $(document).mousemove(function(e){
      $('.spotlight_focus').attr({  'style':'background:radial-gradient(50px 50px at '+ e.clientX +'px '+ e.clientY +'px, transparent, transparent 100px, rgba(0,0,0,0.6) 150px)'});
    });

  
});